import { Entity, Column, PrimaryGeneratedColumn, CreateDateColumn, UpdateDateColumn, VersionColumn } from 'typeorm';

@Entity('revenue_register')
export class DrrExcel {
    @PrimaryGeneratedColumn()
    id: number;


    @Column('int', {
        nullable: true,
        name: "client_id"
    })
    clientId: number;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "client_code"
    })
    clientCode: string;

    @Column('int', {
        default: 1,
        name: "division_id",
    })
    divisionId: number;

    @Column('varchar', {
        default: 1,
        name: "division_code",
    })
    divisionCode: string;

    @Column('int', {
        name: "category_id",
    })
    categoryId: number;

    @Column('int', {
        name: "sub_category_id",
    })
    subCategoryId: number;

    @Column('int', {
        name: "tdy_actual_revenue",
    })
    tdyActualRevenue: number;


    @Column('int', {
        name: "tdy_budget",
    })
    tdyBudget: number;


    @Column('int', {
        name: "tdy_last_year_revenue",
    })
    tdyLastYearRevenue: number;


    @Column('int', {
        name: "tdy_vob",
    })
    tdyVob: number;


    @Column('int', {
        name: "tdy_voly",
    })
    tdyVoly: number;


    @Column('int', {
        name: "mtd_actual",
    })
    mtdActualRevenue: number;


    @Column('int', {
        name: "mtd_budget",
    })
    mtdBudget: number;


    @Column('int', {
        name: "mtd_last_year",
    })
    mtdLastYear: number;


    @Column('int', {
        name: "mtd_vob",
    })
    mtdVob: number;


    @Column('int', {
        name: "mtd_voly",
    })
    mtdVoly: number;

    @Column('int', {
        name: "ytd_actual",
    })
    ytdActualRevenue: number;


    @Column('int', {
        name: "ytd_budget",
    })
    ytdBudget: number;


    @Column('int', {
        name: "ytd_last_year",
    })
    ytdLastYearRevenue: number;


    @Column('int', {
        name: "ytd_vob",
    })
    ytdVob: number;


    @Column('int', {
        name: "ytd_voly",
    })
    ytdVoly: number;

    @CreateDateColumn({
        name: "created_at",
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;



    @Column('varchar', {
        name: 'file_category',
    })
    fileCategory: string;

    @Column('varchar', {
        name: 'date'
    })
    date: string;

}


